
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { defineComponent, ref, onBeforeMount } from 'vue';
import { getApi, postApi } from '@/utils/ApiCalls';
import axios, { AxiosError } from 'axios';
import { getSystemSettings } from '@/utils/system_setting_service';
import router from '@/router';

export default defineComponent({
  name: 'EmailTemplateDetails',
  components: {},
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const templateID = ref(props.query.template);
    const renderReady = ref(true);
    const template = ref({});
    const errorMessage = ref();
    const showUpdate = ref(true);
    const loggedInUser = ref();
    const userRole = ref();
    const showScreen = ref(false);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const isNew = ref(props.query.is_new === 'true');
    const addCC = ref(props.query.add_cc === 'false');
    const isPreview = ref(false);
    const previewShow = ref(false);
    const systSetting = ref();
    const previewContent = ref();
    const learnerOhrs = ref('');
    const ccOhrs = ref('');
    const toOhrPatternMatch = ref(true);
    const ccOhrPatternMatch = ref(true);
    const showCcBtn = ref(false);
    const showSendEmailBtn = ref(false);

    const updateTemplate = async () => {
      try {
        renderReady.value = false;
        template.value = {
          ...template.value,
          is_new: isNew.value,
          add_cc: addCC.value,
        };
        console.log('The Template getting saved is ', template.value);
        const res = await postApi('/email/templates/save', template.value);
        console.log(res);
        resMessage.value = res.data.message;
        renderReady.value = true;
        showSuccessMessage.value = true;
        showErrorMessage.value = false;
        window.scroll(0, 0);
        renderReady.value = true;
      } catch (error) {
        renderReady.value = true;
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          showErrorMessage.value = true;
          showSuccessMessage.value = false;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 5000);
        }
      }
    };

    const openPreview = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const temp = template.value as any;
      let result = '';
      if (temp?.content === '') {
        window.scroll(0, 0);
        resMessage.value = 'Template Content cannot be empty';
        showErrorMessage.value = true;
        showSuccessMessage.value = false;
        setTimeout(() => {
          showErrorMessage.value = false;
        }, 5000);
        return;
      }
      const contentSplitArray = temp?.content.split('$');
      let previousWasUpdated = true;
      contentSplitArray.forEach((item) => {
        if (systSetting.value[item] !== undefined) {
          console.log(systSetting.value[item]);
          result += systSetting.value[item];
          previousWasUpdated = true;
        } else if (previousWasUpdated) {
          result += `${item}`;
          previousWasUpdated = false;
        } else {
          result += `$${item}`;
          previousWasUpdated = false;
        }
      });
      console.log(result);
      previewContent.value = result;

      isPreview.value = !isPreview.value;
    };

    const getTemplate = async () => {
      renderReady.value = false;
      try {
        if (isNew.value === false) {
          const response = await getApi('/email/templates/all');
          console.log('Templates Response ->', templateID.value);
          // eslint-disable-next-line array-callback-return, consistent-return, @typescript-eslint/no-explicit-any
          template.value = response.data.body.Items.find((item: any) => {
            if (templateID.value === item.template_name) {
              console.log('Templates Data ->', item);
              console.log('CC Condition', item.add_cc);
              if (item.add_cc) showCcBtn.value = true;
              console.log('showAcademyDetailBtns', addCC.value);
              return item;
            }
          });
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          renderReady.value = true;
          resMessage.value = err.response?.statusText;
          showErrorMessage.value = true;
          showSuccessMessage.value = false;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 7000);
        }
      }

      renderReady.value = true;
    };

    const matchOHRRegex = (ohr: any, inputType: string) => {
      if (inputType === 'TO') {
        toOhrPatternMatch.value = ohr.match(/^(\d{9},)*\d{9}$/) !== null;
        if (toOhrPatternMatch.value) showSendEmailBtn.value = true;
        else showSendEmailBtn.value = false;
        console.log('toOhrPatternMatch ->', toOhrPatternMatch.value);
      } else {
        ccOhrPatternMatch.value = ohr.match(/^(\d{9},)*\d{9}$/) !== null;
        console.log('ccOhrPatternMatch ->', ccOhrPatternMatch.value);
      }
    };

    const showAcademyDetailBtns = (event: any) => {
      const cb = event.target.checked;
      if (cb) {
        showCcBtn.value = true;
        addCC.value = true;
      } else showCcBtn.value = false;
    };

    const invokeFunction = async () => {
      const routeData = router.resolve({ name: 'SolidifyAdministrationBulkUploadData' });
      window.open(routeData.href, '_blank');
    };

    // const sendEmail = async () => {
    //   try {
    //     renderReady.value = false;
    //     const res = { templateDetails: template.value };
    //     console.log('Template Details -->', res);
    //     // console.log('Template Name', template.value.template_name); , templateName: template.value.template_name
    //     const data = { ohrs: learnerOhrs.value, cc: ccOhrs.value, templateDetails: template.value };
    //     console.log('Data ->', data);
    //     const response = await postApi(`/comms/send/individual/email`, data);
    //     renderReady.value = true;
    //     learnerOhrs.value = '';
    //     ccOhrs.value = '';
    //     showCcBtn.value = false;
    //   } catch (error) {
    //     renderReady.value = true;
    //     console.log('Error while sending emails', error);
    //   }
    // };

    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      loggedInUser.value = role.user_key;
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin')) {
          showScreen.value = true;
          await getTemplate();
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const res: any = await getSystemSettings('system/config');
          systSetting.value = res;
          console.log(res);
        } else {
          showScreen.value = false;
        }
      }
    });

    return {
      templateID,
      showSuccessMessage,
      showScreen,
      resMessage,
      showErrorMessage,
      showUpdate,
      errorMessage,
      renderReady,
      template,
      openPreview,
      updateTemplate,
      isNew,
      addCC,
      isPreview,
      previewContent,
      previewShow,
      learnerOhrs,
      ccOhrs,
      toOhrPatternMatch,
      ccOhrPatternMatch,
      matchOHRRegex,
      showCcBtn,
      showAcademyDetailBtns,
      // sendEmail,
      showSendEmailBtn,
    };
  },
});
